module.exports = __webpack_public_path__ + "static/nma-6f2a0dd48c89fd0ccc2b4e2ec3120b7c.png";